import React from "react"

// Dollar InputNumbers on the Rates page and in the Rate selection modal.
//
// The "$" goes in `prefix` rather than in the formatted text, so the caret can
// never land in front of it ("2212$ 0").
export const formatDollars = (value) => {
    if (value === undefined || value === null || value === "") return ""
    const [whole, fraction] = `${value}`.split(".")
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return fraction === undefined ? grouped : `${grouped}.${fraction}`
}

export const parseDollars = (value) => `${value ?? ""}`.replace(/[$,\s]/g, "")

// antd rebuilds the <input> - and drops focus - whenever a suffix appears or
// disappears, so the warning slot is always rendered and only its content changes.
export const warningSuffix = (show, icon) => <span className="input-warning-suffix">{show ? icon : null}</span>
